import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, Button, Collapse, Grow } from '@mui/material';
import { ArrowDropDownOutlined, ArrowDropUpOutlined, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { HashLink } from 'react-router-hash-link';
import PropTypes from 'prop-types';

const DrawerItem = ({ name, url, isHashLink, isExternal, haveSubItem, subItemDetail, handleDrawerClose }) => {
    const location = useLocation();

    const [subItemDisplay, setSubItemDisplay] = useState(false);

    const isMenuOptionActive = () => {
        let fontWeight = 400;
        if (haveSubItem && subItemDetail.map((item) => item.url).includes(location.pathname)) {
            fontWeight = 700;
        } else if (haveSubItem && subItemDisplay) {
            fontWeight = 700;
        } else if (url === location.pathname || (url === '/blog' && location.pathname.match(/^\/blog(\/.*)?$/))) {
            fontWeight = 700;
        }

        return { fontWeight };
    };

    const getArrowColor = () => {
        const homePage = ['/'];
        const mediaServiceRelatedPage = [
            '/media-service',
            '/data-driven-programmatic',
            '/premium-placement',
            '/campaign-management-service',
            '/china-media-solutions',
            '/ai-creation'
        ];
        const dataServiceRelatedPage = ['/data-service', '/external-data', '/insight-report', '/etl-project'];

        let color = 'transparent';
        if (homePage.includes(location.pathname) || location.pathname.match(/^\/blog(\/.*)?$/)) {
            color = '#E15C12';
        } else if (mediaServiceRelatedPage.includes(location.pathname)) {
            color = '#4D92BB';
        } else if (dataServiceRelatedPage.includes(location.pathname)) {
            color = '#7B6CF9';
        } else {
            color = '#E15C12';
        }

        return color;
    };

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {!isHashLink && (
                    <Button
                        id={name.toLowerCase().replaceAll(' ', '-')}
                        component={isExternal ? 'a' : Link}
                        href={isExternal ? url : undefined}
                        to={!isExternal ? url : undefined}
                        target={isExternal ? '_blank' : undefined}
                        rel={isExternal ? 'noopener noreferrer' : undefined}
                        sx={{
                            color: '#5E5E5E',
                            fontSize: '16px',
                            marginTop: 0,
                            lineHeight: '30px',
                            alignSelf: 'center',
                            justifyContent: 'flex-start !important',
                            cursor: 'pointer',
                            flex: 1,
                            textDecoration: 'none',
                            ...isMenuOptionActive()
                        }}
                        onClick={(event) => {
                            if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
                                event.currentTarget.blur();
                            }
                            handleDrawerClose();
                        }}
                    >
                        {name}
                    </Button>
                )}
                {isHashLink && (
                    <HashLink
                        smooth
                        to={`${url}`}
                        onClick={(event) => {
                            if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
                                event.currentTarget.blur();
                            }
                            handleDrawerClose();
                        }}
                    >
                        <Button
                            id={name.toLowerCase().replaceAll(' ', '-')}
                            sx={{
                                color: '#5E5E5E',
                                fontSize: '16px',
                                marginTop: 0,
                                lineHeight: '30px',
                                alignSelf: 'center',
                                justifyContent: 'flex-start !important',
                                cursor: 'pointer',
                                flex: 1,
                                ...isMenuOptionActive()
                            }}
                        >
                            {name}
                        </Button>
                    </HashLink>
                )}
                {haveSubItem &&
                    (subItemDisplay ? (
                        <KeyboardArrowUp sx={{ color: `${getArrowColor()}` }} onClick={() => setSubItemDisplay(false)} />
                    ) : (
                        <KeyboardArrowDown sx={{ color: `${getArrowColor()}` }} onClick={() => setSubItemDisplay(true)} />
                    ))}
            </Box>
            {haveSubItem && subItemDisplay && (
                <Box sx={{ display: 'flex', flexFlow: 'column', gap: '24px', paddingLeft: '40px' }}>
                    {subItemDetail &&
                        subItemDetail.map((option, index) => (
                            <Grow in={subItemDisplay} {...(subItemDisplay ? { timeout: 500 + index * 150 } : {})}>
                                <Button
                                    id={option.name.toLowerCase().replaceAll(' ', '-')}
                                    component={Link}
                                    to={option.url}
                                    sx={{
                                        color: '#5E5E5E',
                                        fontSize: '16px',
                                        marginTop: 0,
                                        fontWeight: option.url === location.pathname ? 700 : 400,
                                        lineHeight: '30px',
                                        alignSelf: 'flex-start',
                                        justifyContent: 'flex-start !important',
                                        textAlign: 'left',
                                        cursor: 'pointer',
                                        flex: 1,
                                        textDecoration: 'none'
                                    }}
                                    onClick={(event) => {
                                        if (event && event.currentTarget && typeof event.currentTarget.blur === 'function') {
                                            event.currentTarget.blur();
                                        }
                                        handleDrawerClose();
                                    }}
                                >
                                    {option.name}
                                </Button>
                            </Grow>
                        ))}
                </Box>
            )}
        </>
    );
};

DrawerItem.propTypes = {
    name: PropTypes.string,
    isExternal: PropTypes.bool,
    haveSubItem: PropTypes.bool,
    subItemDetail: PropTypes.array,
    url: PropTypes.string
};

export default DrawerItem;
